module.exports = __webpack_public_path__ + "img/MGH-Toyosu-7.7089cfd2.jpg";